module.exports = [{"utc":"Etc/GMT","offset":0,"text":"Etc/GMT (UTC 0)"},{"utc":"Asia/Jakarta","offset":7,"text":"Asia/Jakarta (UTC +7)"},{"utc":"Asia/Makassar","offset":8,"text":"Asia/Makassar (UTC +8)"},{"utc":"Asia/Jayapura","offset":9,"text":"Asia/Jayapura (UTC +9)"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/file/timezone.json
// module id = Zoph
// module chunks = 46